import toastr from 'toastr'

// Deliberately loose: one @, something either side, a dot in the domain. The
// point is to catch typos like "name@gmail" or a missing @, not to police
// every address the RFC allows.
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidEmail = (value) => EMAIL_PATTERN.test(String(value).trim())

export const showError = (message) =>
  toastr.error(message, '', {
    "positionClass": "toast-top-center",
    "showDuration": "300",
    "hideDuration": "1000",
    "timeOut": "5000",
  })
